<template>
  <div class="m-layout" :style="{'border-top': !showTopBar ? 'none' : ''}">
    <MobileMenu :isOpen="menuOpen" @close="closeMenu" @search="showSearch" />

    <!-- 搜索抽屉：整体淡入 -->
    <transition name="fade">
      <div v-if="searchOpen" class="m-search-drawer">
        <div class="m-search-mask" @click="closeSearch" @touchmove.prevent></div>
        <div class="m-search-sheet">
          <MobileSearch
            :visible="searchOpen"
            @update:visible="searchOpen = $event"
            @close="closeSearch"
            section=""
          />
        </div>
      </div>
    </transition>

    <!-- ★ 修改：移除条件类，默认可见 -->
    <main class="m-content">
      <slot />
    </main>

    <Teleport to="body">
      <div class="m-bottom-bar" v-if="!hideBottomBar">
        <div class="m-bottom-bar-icons">
          <button class="m-icon-btn" @click="showSearch">
            <img :src="searchIcon" alt="search" style="width: 12rem;height: 13rem;" />
          </button>
          <button class="m-icon-btn" @click="goEnquiry">
            <img :src="bagIcon" alt="bag" style="width: 11rem;height: 13rem;"/>
          </button>
        </div>
        <button class="m-menu-trigger" @click="openMenu">Menu</button>
        <div class="m-bottom-bar-icons" style="justify-content: flex-end;">
          <button class="m-icon-btn" @click="openEmail">
            <img :src="miniLogo" alt="logo" style="width: 9rem;height: 11rem;" />
          </button>
          <button class="m-icon-btn" @click="goAccount">
            <img :src="userIcon" alt="user" style="width: 11rem;height: 12rem;"/>
          </button>
        </div>
      </div>
    </Teleport>

    <MobileEmail :visible.sync="emailOpen" :auto-show-delay="0" @close="onEmailClose" />
  </div>
</template>

<script>
import MobileMenu from './Menu.vue'
import MobileSearch from './search.vue'
import MobileEmail from './email.vue'

const searchIcon = require('@/assets/icon/search_black.png')
const bagIcon = require('@/assets/icon/product_black.png')
const userIcon = require('@/assets/icon/user_black.png')
const miniLogo = require('@/assets/icon/logo_black.png')

const APP_VERSION = '1.0.1'

export default {
  name: 'MobileLayout',
  components: { MobileMenu, MobileSearch, MobileEmail },
  props: {
    showTopBar: { type: Boolean, default: true },
    hideBottomBar: { type: Boolean, default: false }
  },
  data() {
    return {
      menuOpen: false,
      searchOpen: false,
      emailOpen: false,
      searchIcon,
      bagIcon,
      userIcon,
      miniLogo,
      // isPageReady: false   // ★ 已移除
    }
  },
  mounted() {
    this.checkVersionAndClearCache()
    // ★ 移除 page-ready 事件监听
    window.addEventListener('open-auto-email-popup', this.handleAutoEmailPopup)
    // ★ 移除超时强制 ready 的代码
  },
  beforeDestroy() {
    // ★ 移除 page-ready 事件监听
    window.removeEventListener('open-auto-email-popup', this.handleAutoEmailPopup)
  },
  methods: {
    checkVersionAndClearCache() {
      const storedVersion = localStorage.getItem('app_version_mobile')
      if (storedVersion && storedVersion !== APP_VERSION) {
        if ('caches' in window) {
          caches.keys().then(names => names.forEach(name => caches.delete(name)))
        }
        sessionStorage.clear()
        localStorage.setItem('app_version_mobile', APP_VERSION)
        window.location.reload(true)
        return
      }
      if (!storedVersion) localStorage.setItem('app_version_mobile', APP_VERSION)
    },
    // ★ 移除 onPageReady 方法
    handleAutoEmailPopup() { this.emailOpen = true },
    openEmailPopup() { this.emailOpen = true },
    onEmailClose() {
      localStorage.setItem('emailAutoShown', 'true')
      this.emailOpen = false
    },
    openMenu() { this.menuOpen = true },
    closeMenu() { this.menuOpen = false },
    showSearch() {
      this.menuOpen = false
      this.searchOpen = true
    },
    closeSearch() { this.searchOpen = false },
    openEmail() { this.emailOpen = true },
    goAccount() {
      if (this.$route.path !== '/m/account') this.$router.push('/m/account')
    },
    goEnquiry() {
      if (this.$route.path !== '/m/enquiry') this.$router.push('/m/enquiry')
    }
  }
}
</script>

<style scoped>
.m-layout {
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  background: #ffffff;
  color: #000;
  display: flex;
  flex-direction: column;
}

.m-content {
  flex: 1;
  padding-bottom: calc(45rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(45rem + env(safe-area-inset-bottom));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* ★ 直接可见，无透明过渡 */
  opacity: 1;
  /* 可选保留过渡，但不再影响显示 */
}

/* ★ 移除 .fade-in 类，不再需要 */

.m-bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 45rem;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28rem;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: content-box;
  z-index: 99999 !important;
}
.m-bottom-bar-icons {
  display: flex;
  gap: 20rem;
  width: 40%;
}
.m-icon-btn {
  background: none;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.m-icon-btn img {
  width: 18rem;
  height: 18rem;
  filter: invert(1);
}
.m-menu-trigger {
  background: none;
  border: none;
  font-size: 13rem;
  color: #fff;
  font-family: 'Apercu-Medium', sans-serif !important;
}

.m-search-drawer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  height: 100vh;
  z-index: 9998 !important;
  display: flex;
  align-items: flex-start !important;
  overflow: hidden;
  overscroll-behavior: contain;
}
.m-search-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.35);
  cursor: pointer;
  pointer-events: auto;
  z-index: 0;
}
.m-search-sheet {
  position: relative;
  width: 100%;
  height: calc(100vh - 45rem - env(safe-area-inset-bottom, 0px));
  max-height: calc(100vh - 45rem - env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-self: flex-start;
  pointer-events: auto;
  z-index: 1;
  touch-action: pan-y;
}

/* 淡入过渡（整体淡入） */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>